import React, { useState, useEffect } from 'react';
import './CompanyRegApprovalRejectionScreen_Old.css';
import './RegApprovalRejectionScreen.css'
import RegisterHeader from "../../components/RegisterHeader/RegisterHeader";
import { Globals } from '../../global/Globals';
import RegisterFooter from "../../components/RegisterFooter/RegisterFooter";
import PopUp from "../../components/PopUp/PopUp";
import Toast from "../../components/Toast/Toast";
import { useLocation, useNavigate } from 'react-router-dom';
import { getProducerByProducerID, approveRejectRegistration } from '../../services/SystemAdminAPI';
import { downloadFile } from '../../services/GenericAPI';
import Loader from '../../components/Loader/Loader';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';
import { Globals as OldGlobals } from "../../global/Globals";

const ProducerRegApprovalRejectionScreen = () => {
        const { Globals ,languages, setLanguages } = useLanguage();
    const navigate = useNavigate();
    const location=useLocation();
    const [actionStatus, setActionStatus] = useState({ isApproved: false, isRejected: false });
    const [toast, setToast] = useState({ open: false, status: '', title: "" });
    const [logoDetails, setLogoDetails] = useState({ name: '', type: 'image/*', downloadPath: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [logoSource, setLogoSource] = useState('');
    const [produerData, setProducerData] = useState({
        title: '',
        name: '',
        email: '',
        companyContactNumber: '',
        logofile: '',
        businessAddress: '',
        country: '',
        provience: '',
        website: '',
        socialMediaLinks: '',
        language: '',
        genre: '',
        channels: ''
    })

    const approveProposal = () => {
        setActionStatus({ isApproved: true, isRejected: false });
    }

    const rejectProposal = () => {
        setActionStatus({ isApproved: false, isRejected: true });
    }

    const closePopup = () => {
        setActionStatus({ isApproved: false, isRejected: false });
    }

    const approvalAction = () => {
        approveRejectRegistration(CryptoUtils.getFromLocalStorage('pKey'), true, 'approved').then((response) => {
            if (response?.data?.content?.isSuccess) {
                goToHomeScreen({ open: true, status: 'success', title:Globals.SYS_ADMIN.TOAST_MESSAGE.APPROVE_PRODUCER});
            }
            else {
                goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
            }
        }).catch((error) => {
            console.error("Error in approving the proposal : ", error);
            goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
        })
    }

    const rejectAction = (emailContentText) => {
        approveRejectRegistration(CryptoUtils.getFromLocalStorage('pKey'), false, emailContentText).then((response) => {
            if (response?.data?.content?.isSuccess) {
                goToHomeScreen({ open: true, status: 'success', title:Globals.SYS_ADMIN.TOAST_MESSAGE.REJECT_PRODUCER});
            }
            else {
                goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
            }
        }).catch((error) => {
            console.error("Error in rejecting the proposal : ", error);
            goToHomeScreen({ open: true, status: 'error', title:Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR});
            //renderToast('error', Globals.SYS_ADMIN.TOAST_MESSAGE.ERROR);
        })
    }

    const renderToast = (status, title) => {
        setToast({ open: true, status: status, title: title });
        setTimeout(() => {
            setToast({ open: false, status: '', title: '' });
        }, 4000);
    }

    const goToHomeScreen = (toastValue) => {
         //this is to exe the block only if the control is from Haf screen
                if (location?.state?.producerNavProps?.isFromHalfscreen === true) {
                    localStorage.setItem('isFromProducerPage', true);
                    localStorage.setItem('proposalType', location.state.producerNavProps.selectedTab);
                    navigate(Globals.NAVPATH.HOME, { state: { activeHeader: location.state.producerNavProps.activeHeader, selectedTab: location.state.producerNavProps.selectedTab, page:location.state.producerNavProps.page } })
                }
                else {
                    navigate(Globals.NAVPATH.HOME, {state:{activeHeader:location.state.activeHeader, activeTabData:OldGlobals.ADMIN.INDIVIDUALS, toastValue:toastValue}});
                }
                localStorage.removeItem('pKey');
    }

    useEffect(() => {
        const producerID = CryptoUtils.getFromLocalStorage('pKey');
        setIsLoading(true);
        getProducerByProducerID(producerID).then((response) => {
            setIsLoading(false);
            const respData = response?.data?.content;
            const documents = respData?.documents;
            if (response?.data?.content) {
                //Logo
                const logoFileName = documents?.find(file => file?.documentFor === 'PLOGO')?.documentName;
                const logoFileDPath = documents?.find(file => file?.documentFor === 'PLOGO')?.documentPath;
                setLogoDetails({ name: logoFileName, downloadPath: logoFileDPath });

                const languagesList = respData?.languages.map(language => language.languageName);
                const channelsList = respData?.channels.map(channel => channel.channelName);
                const genresList = respData?.genres.map(genre => genre.genreName);
                const producerRecord = {
                    title: respData?.producer?.title ? respData?.producer?.title : Globals.HALFSCREEN.NA,
                    companyContactNumber: respData?.producer?.companyContactNumber ? respData?.producer?.companyContactNumber : Globals.HALFSCREEN.NA,
                    businessAddress: respData?.producer?.businessAddress ? respData?.producer?.businessAddress : Globals.HALFSCREEN.NA,
                    language: languagesList?.length > 0 ? languagesList.join(', ') : Globals.HALFSCREEN.NA,
                    genre: genresList?.length > 0 ? genresList?.join(', ') : Globals.HALFSCREEN.NA,
                    channels: channelsList?.length > 0 ? channelsList?.join(', ') : Globals.HALFSCREEN.NA,
                    website: respData?.producer?.website ? respData?.producer?.website : Globals.HALFSCREEN.NA,
                    socialMediaLinks: respData?.producer?.socialMediaLinks?respData?.producer?.socialMediaLinks.split(',') : [],
                    country: respData?.producer?.countryName ? respData?.producer?.countryName : Globals.HALFSCREEN.NA,
                    provience: respData?.producer?.provinceName ? respData?.producer?.provinceName : Globals.HALFSCREEN.NA,
                    email: respData?.producer?.email ? respData?.producer?.email : Globals.HALFSCREEN.NA,
                    name: respData?.producer?.name ? respData?.producer?.name : Globals.HALFSCREEN.NA,
                    logofile: respData?.producer?.logofile
                };
                setProducerData(producerRecord);
            }
            else {
                console.error("No producer records found");
                return null;
            }
        }).catch((error) => {
            setIsLoading(false);
            console.error("Error in getting producer details : ", error);
        })
    }, []);

    const downloadSelectedFile = (filePath, fileName) => {
        const isForProducer = true;
        downloadFile(filePath, isForProducer)
            .then((response) => {
                if (response?.data) {
                    const blob = new Blob([response.data]);
                    const fileUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    // Cleanup
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(fileUrl);
                } else {
                    console.error("Error: No file data available for download.");
                }
            })
            .catch((error) => {
                console.error("Error in downloading the file:", error);
            });
    }

    const getLogoSource = async () => {
        try {
            const isForProducer = true;
            const response = await downloadFile(logoDetails.downloadPath, isForProducer);

            if (response?.data) {
                const blob = new Blob([response.data], { type: response.headers['Content-Type'] }); // Ensure correct MIME type
                const fileUrl = URL.createObjectURL(blob);
                // Set image source directly
                setLogoSource(fileUrl);
                setTimeout(() => URL.revokeObjectURL(fileUrl), 5000);
            } else {
                console.error("Error: No file data available for download.");
            }
        } catch (error) {
            console.error("Error in downloading the file:", error);
        }
    };

    useEffect(() => {
        if (logoDetails.downloadPath) {
            getLogoSource();
        }
    }, [logoDetails.downloadPath])

    const getValidURL = (url) => {
        try {
            return new URL(url).href;
        } catch {
            return `https://${url}`;
        }
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
          document.body.style.overflow = "auto";
        };
      }, []);
    return (
        <div className='producer-wrap'>
            <div id="comp-approval-rejection-container" className="comp-approval-rejection-container">
                <RegisterHeader title={Globals.SYS_ADMIN.PRODUCER_UI.TITLE} isBackNotRequired={true} onCancelRegister={goToHomeScreen} />
            </div>
            <div className='prod-body-wrap'>
                <div className='producer-infos-wrap'>
                    <div className='company-infos-inner-wrap'>
                        <div className='company-infos-details1 company-infos-wrap'>
                            <div className='company-details-wrap1'>
                                <div className='reg-apprval-profile-details'>
                                    <div className='company-details-body reg-approval-profile-pic-container'>
                                        <img src={logoSource || Globals.IMG.PROFILE_BIG} alt="Profile" className="reg-approval-profile-photo" />
                                    </div>
                                    <div className="reg-approval-profile-page-details">
                                        <span className="reg-approval-profile-page-company">{"Producer"}</span>
                                        <span className="reg-approval-profile-page-name">{produerData.title && produerData.title.trim() !== "" ? produerData.title.trim().replace(/([^.])$/, '$1.') + " " + produerData.name : produerData.name}</span>
                                        <span className="reg-approval-profile-page-email">{produerData.email}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='company-infos'>{Globals.SYS_ADMIN.PRODUCER_UI.PRODUCER_INFO}</div>
                        <div className='company-infos-details1'>
                            <div className='contact-details-wrap'>
                                <div className='contact-details-head'>{Globals.SIGNUP.LANGUAGE}</div>
                                <div className='contact-details-body user-data-list'>{produerData.language}</div>
                            </div>
                            <div className='contact-details-wrap element-section2'>
                                <div className='contact-details-head'>{Globals.SIGNUP.GENRE}</div>
                                <div className='contact-details-body user-data-list'>{produerData.genre}</div>
                            </div>
                        </div>
                        <div className='company-infos-details1 company-infos-wrap'>
                            <div className='contact-details-wrap '>
                                <div className='contact-details-head'>{Globals.SIGNUP.CHANNELS}</div>
                                <div className='contact-details-body user-data-list'>{produerData.channels}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.WEBSITE}</div>
                                <div className='company-details-body'>{(produerData.website.toLocaleUpperCase() !== Globals.HALFSCREEN.NA)?(<a href={getValidURL(produerData.website)} className={produerData.website !== Globals.HALFSCREEN.NA ? "user-website-url2" : ""} target='_blank'>{Globals.WEBSITE_LINK}</a>):Globals.HALFSCREEN.NA}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.SOCIAL_MEDIA}</div>
                                <div className='company-details-body'>
                                {(produerData.socialMediaLinks.length>0)?
                                    <>
                                        {produerData?.socialMediaLinks?.[0] && <><a href={getValidURL(produerData.socialMediaLinks[0])} target='_blank'>{Globals.SOCIAL_MEDIA_1}</a><br/></>}
                                        {produerData?.socialMediaLinks?.[1] && <><a href={getValidURL(produerData.socialMediaLinks[1])} target='_blank'>{Globals.SOCIAL_MEDIA_2}</a><br/></>}
                                        {produerData?.socialMediaLinks?.[2] && <><a href={getValidURL(produerData.socialMediaLinks[2])} target='_blank'>{Globals.SOCIAL_MEDIA_3}</a><br/></>}
                                    </>:Globals.HALFSCREEN.NA
                                }
                                </div>
                            </div>
                        </div>                        
                            <div className='company-infos'>{Globals.SIGNUP.CONTACT_INFO_LABEL}</div>
                        <div className='company-infos-details2'>
                            <div className='contact-details-wrap'>
                                <div className='contact-details-head'>{Globals.SIGNUP.PHONE_NUMBER}</div>
                                <div className='contact-details-body'>{produerData.companyContactNumber}</div>
                            </div>
                            <div className='company-details-wrap'>
                                <div className='company-details-head'>{Globals.SIGNUP.EMAIL}</div>
                                <div className='company-details-body'>{produerData.email}</div>
                            </div>
                            <div className='contact-details-wrap'>
                                <div className='contact-details-head'>{Globals.SIGNUP.PHYSICAL_ADDRESS}</div>
                                <div className='contact-details-body'>{produerData.businessAddress}</div>
                            </div>
                            <div className='company-details-wrap element-section'>
                                <div className='company-details-head country'>{Globals.SIGNUP.COUNTRY}</div>
                                <div className='company-details-body'>{produerData.country}</div>
                            </div>
                        </div>
                        <div className='company-infos-details2'>
                            <div className='company-details-wrap'>
                                <div className='company-details-head province'>{Globals.SIGNUP.PROVIENCE}</div>
                                <div className='company-details-body'>{produerData.provience}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="reg-approval-footer">
                <span><RegisterFooter tabIndex1={14} tabIndex2={15} isSysAdmin={true} approveProposal={approveProposal} rejectProposal={rejectProposal} onCancelRegister={goToHomeScreen} /></span>
            </div>
            {actionStatus.isApproved && <PopUp
                title={Globals.SYS_ADMIN.POPUP.APPROVE_PRODUCER_POPUP_TITLE}
                popupType="approveProposal-Producer"
                email={false}
                limit="1024"
                customClassName="email-popup-content"
                onClose={closePopup}
                normalAction={()=>approvalAction()}
                normalActionText={Globals.SYS_ADMIN.CTA.APPROVE}
                textAreaStyle="popup-email-text"
                textAreaTitle={Globals.SYS_ADMIN.POPUP.EMAIL_CONTENT}
                proposalBodyVal={"Body"}
            />}
            {actionStatus.isRejected && <PopUp
                title={Globals.SYS_ADMIN.POPUP.REJECT_POPUP_PRODUCER_TITLE}
                popupType="rejectProposal-Producer"
                email={true}
                limit="1024"
                customClassName="email-popup-content"
                onClose={closePopup}
                negativeAction={rejectAction}
                negativeActionText={Globals.SYS_ADMIN.CTA.REJECT}
                textAreaStyle="popup-email-text"
                textAreaTitle={Globals.SYS_ADMIN.POPUP.EMAIL_CONTENT}
                proposalBodyVal={"Body"}
                emailContent={Globals.SYS_ADMIN.POPUP.REJECT_EMAIL_TEMPLATE}
            />}
            {toast.open && <Toast status={toast.status} title={toast.title} />}
            {isLoading && <Loader width={50} height={50} component={'prod-user-approve-reject'} />}

        </div>
    )
}

export default ProducerRegApprovalRejectionScreen;